<template>
  <modal
    title="Share pay link"
    width="35"
    :showModal="showModal"
    @close-modal="closeModal"
  >
    <div class="w-full text-primary-yellow py-2">
      View Bill
    </div>
    <div class="individual-contaoner">
      <label class="label">Pay Link</label>
      <div class="flex items-center input-field px-2">
        <input
          v-model="paylink"
          :disabled="true"
          placeholder="--Autoloaded--"
          class="w-full py-2 pl-2 bg-transparent mr-3"
        />
        <img
          @click="copyPayLink"
          src="@/assets/images/icons/copy.svg"
          class="cursor-pointer"
        />
      </div>
    </div>

    <div class="individual-contaoner">
      <label class="label">Customer’s Email </label>
      <input
        v-model="companyEmail"
        placeholder="--Autoloaded--"
        class="w-full py-2 pl-3 input-field cursor-not-allowed"
      />
    </div>

    <div class="individual-contaoner">
      <label class="label">Payment Amount (NGN) </label>
      <input
        v-model="amount"
        :disabled="true"
        placeholder="--Autoloaded--"
        class="w-full py-2 pl-3 input-field"
      />
    </div>



    <div class="actions flex items-center justify-end cursor-pointer mt-20">
      <div>
        <primary-button
          class="shadow-md"
          buttonText="Submit"
          :loading="loading"
          @click="payLink"
        />
      </div>
      <div>
        <p @click="closeModal()" class="pl-3">Cancel</p>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    paymentParams: {
      type: Object,
    },
  },

  data() {
    return {
      paylink: "",
      amount: "",
      companyEmail: "",
      note: "",
    };
  },

  mounted() {},
  watch: {
    showModal(val){
        val ? this.payLink() : null
        this.amount = this.$store.getters.quoteResponse.totalValue
    },
    paymentParams() {},
  },
  computed: {
    shippingId() {
      return this.$store.getters.quoteResponse?.shipping?.id;
    },
    payload() {
      return {
        status: "paid",
        userId: "",
        totalValue: 3000,
        paymentStatus: "paid",
        breakDown: {
          vat: 50,
          insuranceFee: 400,
          handlingCharges: 90,
          note: this.note,
          amount_paid: this.amount,
          payment_type: this.paymentType,
          payment_date: "",
          orgId: "",
        },
        productId: "",
      };
    },
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
    copyPayLink() {
      navigator.clipboard.writeText(this.paylink);
      this.generateToast("Payment-link copied successfully", "success");
    },
    async payLink() {
      try {
        const response = await this.$_sharePayLink(this.shippingId);
        this.paylink = response.data.paymentUrl
        this.copyPayLink()
      } catch (error) {
        //
      }
    },
  },
};
</script>

<style scoped lang="scss">
.label {
  @apply w-full pb-0;
  font-size: 13px;
}
.individual-contaoner {
  @apply w-full p-2 my-0;
}
.filter-search {
  border-radius: 4px;
  @apply py-2;
}
.input-field {
  @apply bg-gray-200;
}
</style>
